export default "__VITE_PUBLIC_ASSET__37584285__"